function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_13037",
  width: 24,
  height: 24,
  fill: "currentColor"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_67760",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_146293",
  d: "M12.284,12.661a3.448,3.448,0,0,0,3.292-3.578,3.385,3.385,0,0,0-3.292-3.488,3.409,3.409,0,0,0-3.3,3.5A3.445,3.445,0,0,0,12.284,12.661Zm0-1.3A2.11,2.11,0,0,1,10.355,9.1a2.062,2.062,0,0,1,1.929-2.2,2.057,2.057,0,0,1,1.929,2.185A2.12,2.12,0,0,1,12.284,11.358ZM10.6,19.667h6.381c1.3,0,1.921-.407,1.921-1.288,0-2.064-2.576-4.837-6.622-4.837a7.749,7.749,0,0,0-3.435.776A4.706,4.706,0,0,1,9.8,15.336a6.207,6.207,0,0,1,2.479-.49c3.33,0,5.2,2.17,5.2,3.322,0,.143-.068.2-.249.2H10.807A4.449,4.449,0,0,1,10.6,19.667ZM5.865,22.131a3.876,3.876,0,1,0,0-7.752,3.876,3.876,0,1,0,0,7.752Zm0-1.416a.482.482,0,0,1-.512-.512V18.771H3.921a.512.512,0,1,1,0-1.025H5.353V16.315a.512.512,0,1,1,1.025,0v1.431H7.809a.512.512,0,1,1,0,1.025H6.377V20.2A.482.482,0,0,1,5.865,20.714Z",
  transform: "translate(-0.284 -0.799)",
  fill: "currentColor"
}));

function SvgInviteGhost(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteGhost);
export default __webpack_public_path__ + "static/media/invite-ghost.373a442a.svg";
export { ForwardRef as ReactComponent };